// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/directory/v1/directory.proto" (package "c1.api.directory.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * The fields to be included in the directory response.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryExpandMask
 */
export interface DirectoryExpandMask {
    /**
     * An array of fields to be included in the directory response.
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * This object indicates that an app is also a directory.
 *
 * @generated from protobuf message c1.api.directory.v1.Directory
 */
export interface Directory {
    /**
     * The ID of the app associated with the directory.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The datetime, in RFC3339 format, of when the Directory was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Directory was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the Directory was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf oneof: account_filter
     */
    accountFilter: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterAll all = 101;
         */
        all: DirectoryAccountFilterAll;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102;
         */
        celExpression: DirectoryAccountFilterCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryAccountFilterAll
 */
export interface DirectoryAccountFilterAll {
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryAccountFilterCel
 */
export interface DirectoryAccountFilterCel {
    /**
     * @generated from protobuf field: string expression = 1;
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryRef
 */
export interface DirectoryRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * The directory view contains a directory and an app_path which is a JSONPATH set to the location in the expand mask that the expanded app will live if requested by the expander.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryView
 */
export interface DirectoryView {
    /**
     * The directory object being returned by the request.
     *
     * @generated from protobuf field: c1.api.directory.v1.Directory directory = 1;
     */
    directory?: Directory;
    /**
     * JSONPATH expression indicating the location of the App object in the array.
     *
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
}
/**
 * The Directory Service Get Response returns a directory view with a directory and JSONPATHs indicating the
 * location in the expanded array that items are expanded as indicated by the expand mask in the request.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceGetResponse
 */
export interface DirectoryServiceGetResponse {
    /**
     * A view of the directory, contains the serialized directory and paths to objects referenced by the directory.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryView directory_view = 1;
     */
    directoryView?: DirectoryView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * Uplevel an app into a full directory.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceCreateRequest
 */
export interface DirectoryServiceCreateRequest {
    /**
     * The AppID to make into a directory, providing identities and more for the C1 app.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 2;
     */
    expandMask?: DirectoryExpandMask;
    /**
     * @generated from protobuf oneof: account_filter
     */
    accountFilter: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterAll all = 101;
         */
        all: DirectoryAccountFilterAll;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102;
         */
        celExpression: DirectoryAccountFilterCel;
    } | {
        oneofKind: undefined;
    };
}
/**
 * The DirectoryServiceCreateResponse message.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceCreateResponse
 */
export interface DirectoryServiceCreateResponse {
    /**
     * A view of the directory, contains the serialized directory and paths to objects referenced by the directory.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryView directory_view = 1;
     */
    directoryView?: DirectoryView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * Update a directory by app_id.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceUpdateRequest
 */
export interface DirectoryServiceUpdateRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf oneof: account_filter
     */
    accountFilter: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterAll all = 101;
         */
        all: DirectoryAccountFilterAll;
    } | {
        oneofKind: "celExpression";
        /**
         * @generated from protobuf field: c1.api.directory.v1.DirectoryAccountFilterCel cel_expression = 102;
         */
        celExpression: DirectoryAccountFilterCel;
    } | {
        oneofKind: undefined;
    };
    /**
     * The list of paths to expand in the return value expanded list.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 2;
     */
    expandMask?: DirectoryExpandMask;
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceUpdateResponse
 */
export interface DirectoryServiceUpdateResponse {
    /**
     * A view of the directory, contains the serialized directory and paths to objects referenced by the directory.
     *
     * @generated from protobuf field: c1.api.directory.v1.DirectoryView directory_view = 1;
     */
    directoryView?: DirectoryView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceGetRequest
 */
export interface DirectoryServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 2;
     */
    expandMask?: DirectoryExpandMask;
}
/**
 * DirectoryServiceDeleteRequest is the request message for deleting a directory. It uses URL values for input.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceDeleteRequest
 */
export interface DirectoryServiceDeleteRequest {
    /**
     * The app_id of the directory to delete.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceDeleteResponse
 */
export interface DirectoryServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceListRequest
 */
export interface DirectoryServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 3;
     */
    expandMask?: DirectoryExpandMask;
}
/**
 * The DirectoryServiceListResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceListResponse
 */
export interface DirectoryServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.directory.v1.DirectoryView list = 1;
     */
    list: DirectoryView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceSearchRequest
 */
export interface DirectoryServiceSearchRequest {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.directory.v1.DirectoryExpandMask expand_mask = 4;
     */
    expandMask?: DirectoryExpandMask;
    /**
     * The refs to search for.
     *
     * @generated from protobuf field: repeated c1.api.directory.v1.DirectoryRef refs = 5;
     */
    refs: DirectoryRef[];
}
/**
 * @generated from protobuf message c1.api.directory.v1.DirectoryServiceSearchResponse
 */
export interface DirectoryServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.directory.v1.DirectoryView list = 1;
     */
    list: DirectoryView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryExpandMask$Type extends MessageType<DirectoryExpandMask> {
    constructor() {
        super("c1.api.directory.v1.DirectoryExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryExpandMask
 */
export const DirectoryExpandMask = new DirectoryExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Directory$Type extends MessageType<Directory> {
    constructor() {
        super("c1.api.directory.v1.Directory", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 101, name: "all", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterAll },
            { no: 102, name: "cel_expression", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterCel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.Directory
 */
export const Directory = new Directory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryAccountFilterAll$Type extends MessageType<DirectoryAccountFilterAll> {
    constructor() {
        super("c1.api.directory.v1.DirectoryAccountFilterAll", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryAccountFilterAll
 */
export const DirectoryAccountFilterAll = new DirectoryAccountFilterAll$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryAccountFilterCel$Type extends MessageType<DirectoryAccountFilterCel> {
    constructor() {
        super("c1.api.directory.v1.DirectoryAccountFilterCel", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryAccountFilterCel
 */
export const DirectoryAccountFilterCel = new DirectoryAccountFilterCel$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryRef$Type extends MessageType<DirectoryRef> {
    constructor() {
        super("c1.api.directory.v1.DirectoryRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryRef
 */
export const DirectoryRef = new DirectoryRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryView$Type extends MessageType<DirectoryView> {
    constructor() {
        super("c1.api.directory.v1.DirectoryView", [
            { no: 1, name: "directory", kind: "message", T: () => Directory },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryView
 */
export const DirectoryView = new DirectoryView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceGetResponse$Type extends MessageType<DirectoryServiceGetResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceGetResponse", [
            { no: 1, name: "directory_view", kind: "message", T: () => DirectoryView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceGetResponse
 */
export const DirectoryServiceGetResponse = new DirectoryServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceCreateRequest$Type extends MessageType<DirectoryServiceCreateRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask },
            { no: 101, name: "all", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterAll },
            { no: 102, name: "cel_expression", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterCel }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceCreateRequest
 */
export const DirectoryServiceCreateRequest = new DirectoryServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceCreateResponse$Type extends MessageType<DirectoryServiceCreateResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceCreateResponse", [
            { no: 1, name: "directory_view", kind: "message", T: () => DirectoryView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceCreateResponse
 */
export const DirectoryServiceCreateResponse = new DirectoryServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceUpdateRequest$Type extends MessageType<DirectoryServiceUpdateRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceUpdateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 101, name: "all", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterAll },
            { no: 102, name: "cel_expression", kind: "message", oneof: "accountFilter", T: () => DirectoryAccountFilterCel },
            { no: 2, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceUpdateRequest
 */
export const DirectoryServiceUpdateRequest = new DirectoryServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceUpdateResponse$Type extends MessageType<DirectoryServiceUpdateResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceUpdateResponse", [
            { no: 1, name: "directory_view", kind: "message", T: () => DirectoryView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceUpdateResponse
 */
export const DirectoryServiceUpdateResponse = new DirectoryServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceGetRequest$Type extends MessageType<DirectoryServiceGetRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceGetRequest
 */
export const DirectoryServiceGetRequest = new DirectoryServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceDeleteRequest$Type extends MessageType<DirectoryServiceDeleteRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceDeleteRequest
 */
export const DirectoryServiceDeleteRequest = new DirectoryServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceDeleteResponse$Type extends MessageType<DirectoryServiceDeleteResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceDeleteResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceDeleteResponse
 */
export const DirectoryServiceDeleteResponse = new DirectoryServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceListRequest$Type extends MessageType<DirectoryServiceListRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceListRequest
 */
export const DirectoryServiceListRequest = new DirectoryServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceListResponse$Type extends MessageType<DirectoryServiceListResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DirectoryView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceListResponse
 */
export const DirectoryServiceListResponse = new DirectoryServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceSearchRequest$Type extends MessageType<DirectoryServiceSearchRequest> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceSearchRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => DirectoryExpandMask },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DirectoryRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceSearchRequest
 */
export const DirectoryServiceSearchRequest = new DirectoryServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryServiceSearchResponse$Type extends MessageType<DirectoryServiceSearchResponse> {
    constructor() {
        super("c1.api.directory.v1.DirectoryServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DirectoryView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.directory.v1.DirectoryServiceSearchResponse
 */
export const DirectoryServiceSearchResponse = new DirectoryServiceSearchResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.directory.v1.DirectoryService
 */
export const DirectoryService = new ServiceType("c1.api.directory.v1.DirectoryService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/directories/{app_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Directory", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Directory" }] } }, I: DirectoryServiceGetRequest, O: DirectoryServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/directories", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Directory", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Directories", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "Directory", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: DirectoryServiceListRequest, O: DirectoryServiceListResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/directories", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Directory" }], group: "Directory" }] } }, I: DirectoryServiceCreateRequest, O: DirectoryServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/directories/{app_id}", group: "Directory" }] } }, I: DirectoryServiceDeleteRequest, O: DirectoryServiceDeleteResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "PUT", route: "/api/v1/directories/{app_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Directory" }], group: "Directory" }] } }, I: DirectoryServiceUpdateRequest, O: DirectoryServiceUpdateResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: DirectoryServiceSearchRequest, O: DirectoryServiceSearchResponse }
]);
